module.exports = __webpack_public_path__ + "static/media/cch.b6d72ab4.jpg";